export const ultimasNoticias = [
    {
        "imagen" : "../img/noticias/Corto2026_1.png",
        "url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/contraloriat/dir1/Documentos/TRANSP%20EN%20CORTO_CONVOCATORIA_2026.pdf",
        "titulo" : " 🎥 CONVOCATORIA 🎞️ ",
        "fecha" : " Concurso Nacional de Transparencia en Corto 2026"
    },
    //  {
    //     "imagen" : "../img/noticias/ventanilla/2.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyo por Catástrofes Agropecuarias 2025"
    // },
    //  {
    //     "imagen" : "../img/noticias/ventanilla/3.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyo por Catástrofes Agropecuarias 2025"
    // },
    //  {
    //     "imagen" : "../img/noticias/ventanilla/4.jpg",
    //     "url" : "https://sader.hidalgo.gob.mx/CampoDigital",
    //     "titulo" : "CONVOCATORIA",
    //     "fecha" : "Programa de Apoyo por Catástrofes Agropecuarias 2025"
    // },
     
    
]
